import * as React from 'react';
import { History } from 'history';
import Model from './event-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  url?: string;
  parentId?: number;
  actions?: any;
  astemplate?: string;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoadAll?: (data: any) => void;
}

interface IState {
}

export default class EventList extends React.Component<IProps, IState> {
    
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    
  }

  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.parentId} id={this.props.parentId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.astemplate, this.props.parentId)} url={(this.props.root || '') + (this.props.url || Model.url)} model={Model} actions={this.props.actions} onLoadAll={this.onLoadAll} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
